<template>
    <div class="settings-sidemenu">
        <div class="submenu-section">
            <GekkoButton 
                :text="$gettext('Back to Gekko')"
                :href="Urls['gekko_dashboard']()"
                icon="fa-solid fa-arrow-left"
                class="w-100"
            />
        </div>
        <div v-if="is_staff" class="submenu-section">
            <ul class="submenu">
                <li class="nav-item">
                    <a href="/tokeh"><font-awesome-icon icon="fa-solid fa-gears" /><span v-translate>Go to admin</span></a>
                </li>
            </ul>
        </div>

        <div v-if="!loading">

            <!-- Accountant settings -->
            <div v-show="currentUser.is_accountant && !currentCompany.has_accountant" :class="(currentUser.is_accountant && currentCompany.has_accountant)? 'submenu-section' : ''">
                <h4 class="submenu-title" v-translate>Account</h4>
                <ul class="submenu">
                    <li class="nav-item first" :class="currentPage.includes(Urls['accounts_manage_companies']()) && 'active'">
                        <router-link :to="Urls['accounts_manage_companies']()">
                            <font-awesome-icon icon="fa-solid fa-briefcase" />
                            <span v-translate>Company details</span>
                        </router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_edit_profile']()) && 'active'">
                        <router-link :to="Urls['accounts_edit_profile']()">
                            <font-awesome-icon icon="fa-solid fa-cog" />
                            <span v-translate>Personal profile</span>
                        </router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_change_password']()) && 'active'">
                        <router-link :to="Urls['accounts_change_password']()">
                            <font-awesome-icon icon="fa-solid fa-lock" />
                            <span v-translate>Change password</span>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- Regular user settings -->
            <div v-show="!currentUser.is_accountant" class="submenu-section">
                <h4 class="submenu-title" v-translate>Account</h4>
                <ul class="submenu">
                    <li class="nav-item first" :class="currentPage.includes(Urls['accounts_edit_profile']()) && 'active'">
                        <router-link :to="Urls['accounts_edit_profile']()"><font-awesome-icon icon="fa-solid fa-cog" /><span v-translate>My profile</span></router-link>
                    </li>
                    <li class="nav-item last webapp-hide-disabled" :class="currentPage.includes(Urls['subscriptions:manage']()) && 'active'">
                        <router-link :to="Urls['subscriptions:manage']()"><font-awesome-icon icon="fa-solid fa-eur" /><span v-translate>Subscriptions</span></router-link>
                    </li>
                    <li class="nav-item" :class="(currentPage.includes(Urls['accounts_team_settings']()) || currentPage.includes(Urls['accounts_team_new_settings']())) && 'active'">
                        <router-link :to="Urls['accounts_team_new_settings']()"><font-awesome-icon icon="fa-solid fa-users" /><span v-translate>Team</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_notification_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_notification_settings']()"><font-awesome-icon icon="fa-solid fa-bells" /><span v-translate>Notifications</span></router-link>
                    </li>
                </ul>
            </div>

            <!-- Company settings -->
            <div v-show="showCompanySettings" class="submenu-section">
                <h4 class="submenu-title company-title" v-translate>Companies</h4>
                <ul class="submenu company-settings">
                    <li class="nav-item"  :class="currentPage.includes(Urls['accounts_manage_companies']()) && 'active'">
                        <router-link :to="Urls['accounts_manage_companies']()"><font-awesome-icon icon="fa-solid fa-briefcase" /><span v-translate>Company details</span></router-link>
                    </li>
                    <li class="nav-item" :class="(currentPage === Urls['accounts_invoice_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_invoice_settings']()"><font-awesome-icon icon="fa-solid fa-file" /><span v-translate>Invoice settings</span></router-link>
                    </li>
                    <li class="nav-item webapp-hide-disabled" :class="currentPage.includes(Urls['accounts_invoice_design_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_invoice_design_settings']()"><font-awesome-icon icon="fa-solid fa-paintbrush" /><span v-translate>Invoice design</span></router-link>
                    </li>
                    <li class="nav-item webapp-hide-disabled" :class="currentPage.includes(Urls['products:home']()) && 'active'">
                        <router-link :to="Urls['products:home']()"><font-awesome-icon icon="fa-solid fa-basket-shopping" /><span v-translate>Products</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_costtypes_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_costtypes_settings']()"><font-awesome-icon icon="fa-solid fa-cart-shopping" /><span v-translate>Cost categories</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_cars_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_cars_settings']()"><font-awesome-icon icon="fa-solid fa-truck" /><span v-translate>Cars</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_import_data_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_import_data_settings']()" data-analytics-click="import data"><font-awesome-icon icon="fa-solid fa-upload" /><span v-translate>Import data</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_download_data_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_download_data_settings']()"><font-awesome-icon icon="fa-solid fa-file" /><span v-translate>Download data</span></router-link>
                    </li>
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_ideal_payment_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_ideal_payment_settings']()"><font-awesome-icon icon="fa-regular fa-credit-card" /><span v-translate>iDEAL Payment</span></router-link>
                    </li>
                    <!--<li class="nav-item{% if active == 'bank_connection' %} active{% endif %}">
                        <a href="{% url 'accounts_bank_connection' %}"><font-awesome-icon icon="fa-regular fa-credit-card" />{% trans 'Bank connection' %}</a>
                    </li>-->
                    <li class="nav-item" :class="currentPage.includes(Urls['accounts_webshop_settings']()) && 'active'">
                        <router-link :to="Urls['accounts_webshop_settings']()"><font-awesome-icon icon="fa-solid fa-earth-americas" /><span v-translate>Webshop</span></router-link>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="loading" class="submenu-section">
            <h4 class="submenu-title" v-translate>Account</h4>
            <ul class="submenu">
                <li class="nav-item first skeleton-element"><b-skeleton></b-skeleton></li>
            </ul>
            <ul v-for="i in Array.from({length: 5})" :key="i" class="submenu">
                <li class="nav-item skeleton-element"><b-skeleton></b-skeleton></li>
            </ul>
        </div>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import { mapGetters } from "vuex";

export default {
    name: "SettingsSidemenu",
    components: {
        GekkoButton
    },
    watch: {
        currentUser() {
            this.loading = false
        }
    },
    data() {
        return {
            is_staff: window.is_staff,
            loading: true
        }
    },
    computed: {
        currentPage() {
            return this.$route.path;
        },
        showCompanySettings(){
            if(this.currentUser.is_accountant){
                if(this.currentCompany.has_accountant){
                    return true;
                }else{
                    return false;
                }
            }
            if(!this.currentUserRights.edit_company_profile){
                return false;
            }
            return true;
        },
        ...mapGetters({
            currentUser: "main/getCurrentUser",
            currentCompany: "main/getCurrentCompany",
            currentUserRights: "main/getCurrentRights"
        })
    }
};
</script>
<style lang="scss" scoped>
.settings-sidemenu { // inherited from settings_base.less
    font-size: 1rem;
    .submenu {
        li {
            a {
                .svg-inline--fa { margin-right: 0.5rem; width: 20px; opacity: 0.2; }
            }

            &.active a, a:hover {
                .svg-inline--fa { opacity: 0.5; }
            }


        }
    }

}

.skeleton-element {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
</style>
